import { render, staticRenderFns } from "./SearchItemTitle.vue?vue&type=template&id=32686665&scoped=true&"
import script from "./SearchItemTitle.vue?vue&type=script&lang=js&"
export * from "./SearchItemTitle.vue?vue&type=script&lang=js&"
import style0 from "./SearchItemTitle.vue?vue&type=style&index=0&id=32686665&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32686665",
  null
  
)

export default component.exports